import { Avatar, Button, Form, Input, List, message, Modal, Spin, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { PlusCircleFilled, UserOutlined, CheckCircleFilled } from "@ant-design/icons";
import { TitleCompanyHandle } from '../../TitleCompany/state/action';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { formatPhoneNumber, generateInitialsFromObj } from '../../Common/utils/universalFuntions';
import PhoneInput from 'react-phone-input-2';
import { closingActions } from '../../TransactionReport/state/actions';
import { contractStoreHandle } from '../../ContractStore/state/actions';
const { confirm } = Modal;

function TitleSignerList({ setModalState, modalState, rootDocData, accessToken, currentUrlId }) {
    const dispatch = useDispatch();
    const { selectedTitleCompanyError, selectedTitleCompanyLoading, selectedTitleCompanyData } = useSelector((state) => state?.titleCompanyDetails);
    const [titleSignerArray, setTitleSignerArray] = useState([]);
    const [selectedSigner, setSelectedSigner] = useState([]);
    const [openProcessorForm, setOpenProcessorForm] = useState(false);
    const [getTitleCompany, setGetTitleCompany] = useState(false);

    const handleSelect = (signer) => {
        const isAlreadySelected = selectedSigner?.some(
            (s) => s.email === signer.email && s.name === signer.name
        );

        if (isAlreadySelected) {
            // deselect signer if clicked again
            setSelectedSigner((prev) =>
                prev.filter(
                    (s) => !(s.email === signer.email && s.name === signer.name)
                )
            );
        } else if (selectedSigner?.length >= 1) {
            // limit to only one signer
            message.warning("Only one signer can be selected.");
        } else {
            setSelectedSigner((prev) => [...prev, signer]);
        }
    };

    const handleCancel = () => {
        setModalState((prevState) => ({ ...prevState, showTitleSignerList: false }));
    }

    useEffect(() => {
      if (currentUrlId) {
        let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
        if (localData?.TitleReps && Array.isArray(localData?.TitleReps) && localData?.TitleReps?.length > 0) {
            setSelectedSigner(localData?.TitleReps);
        }
      }
    }, [])

    let sourceAxios = axios.CancelToken.source();
    useEffect(() => {
        let unmounted = {
            value: false,
        }
        dispatch(TitleCompanyHandle?.getSelectedTitleCompanyDataFromOffer({
            // FOR CI and for Haymeadow > HH_CRA and HH_LRA
            ...(rootDocData?.offerId ? { offerId: rootDocData?.offerId } : { propertyId: rootDocData?.propertyId }),
            accessToken,
            sourceAxios,
            unmounted,
            openFor: rootDocData?.openFor
        }))
    }, [getTitleCompany]);

    useEffect(() => {
        if (selectedTitleCompanyData && Object.keys(selectedTitleCompanyData).length > 0) {
            let tempArray = [];
            if (selectedTitleCompanyData?.salesRepName && selectedTitleCompanyData?.salesRepEmail) {
                tempArray.push({
                    type: "SALES_REP",
                    name: selectedTitleCompanyData?.salesRepName,
                    email: selectedTitleCompanyData?.salesRepEmail,
                })
            }
            if (selectedTitleCompanyData?.titleCloserName && selectedTitleCompanyData?.titleCloserEmail) {
                tempArray.push({
                    type: "CLOSER",
                    name: selectedTitleCompanyData?.titleCloserName,
                    email: selectedTitleCompanyData?.titleCloserEmail,
                })
            }
            if (selectedTitleCompanyData?.processors?.length > 0) {
                selectedTitleCompanyData?.processors.forEach((element) => {
                    tempArray.push({
                        type: "PROCESSOR",
                        name: element?.name,
                        email: element?.email,
                    })
                })
            }

            setTitleSignerArray(tempArray);
        }
    }, [selectedTitleCompanyData]);

    const openProcessorFormFunc = () => {
        setOpenProcessorForm(true);
    }

    const handleSubmitProcessor = (values) => {
        if (values?.name?.trim() === "" || !values?.name || values?.email?.trim() === "" || !values?.email) {
            message.error("Please fill all required fields.");
            return;
        }
        // setTitleSignerArray((prev) => [...prev, newSigner]);
        let payload = {
            ...(rootDocData?.offerId ? { offerId: rootDocData?.offerId } : { propertyId: rootDocData?.propertyId }),
            openFor: rootDocData?.openFor,
            selectedBy: selectedTitleCompanyData?.selectedBy || rootDocData?.openFor,
            processors: [
                ...selectedTitleCompanyData?.processors,
                {
                    name: (values?.name).trim(),
                    email: values?.email ? values.email.toLowerCase().trim() : "",
                    phoneNumber: values?.phoneNumber ? formatPhoneNumber(values.phoneNumber) : ""
                }
            ]
        }
        dispatch(closingActions.addTitleOffice(payload, accessToken, rootDocData, { source: "TITLE_SIGNER_LIST", setGetTitleCompany, getTitleCompany, setOpenProcessorForm }));
    };

    // Final Signer Selection Confirmation
    const handleConfirmSignerSelection = () => {
        // if (selectedSigner?.length === 0) {
        //     message.error("Please select a signer.");
        //     return;
        // }

        confirm({
            title: 'Confirm Signer Selection',
            content: ( selectedSigner?.length === 0 ? <span>Are you sure you want to continue with <strong>No</strong> Title Signer?</span> :
                <span>Are you sure you want to select <strong>{selectedSigner[0]?.name}</strong> as the Title Signer to sign this document?</span>
            ),
            okText: 'Yes',
            cancelText: 'No',
            onOk() {
                let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
                localStorage.setItem(currentUrlId, JSON.stringify({ ...localData, TitleReps: selectedSigner || [] }));
                dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey: accessToken, valueObj: { TitleReps: selectedSigner } }));
                handleCancel();
                message.success("Title Signer added successfully!");
            },
            onCancel() {
                handleCancel();
            },
        })
    }

    return (
        <div>
            <Modal
                title={
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                        <div className='commonModalTitle'>Title Signers</div>
                        {(!selectedTitleCompanyLoading && !selectedTitleCompanyError) && <Tooltip title="Add Processor">
                            <PlusCircleFilled onClick={openProcessorFormFunc} style={{ fontSize: "20px", fill: "#085191", color: "#085191", cursor: "pointer" }} />
                        </Tooltip>}
                    </div>
                }
                visible={true}
                footer={null}
                bodyStyle={{ padding: 10 }}
                onCancel={handleCancel}
            >
                {selectedTitleCompanyLoading ? <div style={{ width: "100%", height: "10vh", display: "flex", justifyContent: "center", alignItems: "center" }}><Spin /></div> :
                    selectedTitleCompanyError ? <div style={{ color: "red", textAlign: 'center' }}>{selectedTitleCompanyError}</div> :
                        (selectedTitleCompanyData && Object.keys(selectedTitleCompanyData).length > 0 && titleSignerArray?.length === 0) ? <div style={{ textAlign: "center" }}>No Signers Available Please add Processor on Plus icon</div> :
                            titleSignerArray?.length > 0 ? (
                                <div style={{ maxHeight: '350px', overflowY: 'auto', marginBottom: '20px' }}>
                                    <List
                                        itemLayout="horizontal"
                                        dataSource={titleSignerArray}
                                        renderItem={(signer) => {
                                            let initials = generateInitialsFromObj({ fullName: signer?.name });
                                            const isSelected = selectedSigner.some(
                                                (s) => s.email === signer.email && s.name === signer.name
                                            );

                                            return (
                                                <List.Item
                                                    style={{
                                                        padding: "12px 16px",
                                                        cursor: "pointer",
                                                        transition: "background 0.3s ease",
                                                        background: isSelected ? "#f0faff" : "transparent", // highlight selected row
                                                    }}
                                                    onClick={() => handleSelect(signer)}
                                                >
                                                    <List.Item.Meta
                                                        avatar={
                                                            signer?.profileImg?.original ? (
                                                                <Avatar
                                                                    size={45}
                                                                    src={signer.profileImg.original}
                                                                    style={{
                                                                        border: "2px solid #085191",
                                                                        background: "#347FC0",
                                                                    }}
                                                                />
                                                            ) : initials ? (
                                                                <Avatar size={45} style={{ background: "#085191" }}>
                                                                    {initials}
                                                                </Avatar>
                                                            ) : (
                                                                <Avatar
                                                                    size={45}
                                                                    icon={<UserOutlined />}
                                                                    style={{ background: "#085191" }}
                                                                />
                                                            )
                                                        }
                                                        title={
                                                            <span style={{ fontSize: "16px", fontWeight: 500 }}>
                                                                {signer.name}
                                                            </span>
                                                        }
                                                        description={
                                                            signer?.email && (
                                                                <span style={{ color: "#666" }}>{signer.email}</span>
                                                            )
                                                        }
                                                    />

                                                    {isSelected && (
                                                        <CheckCircleFilled style={{ color: "green", fontSize: 20 }} />
                                                    )}
                                                </List.Item>
                                            );
                                        }}
                                    />
                                </div>
                            ) : ""
                }

                {(!selectedTitleCompanyLoading &&
                    !selectedTitleCompanyError &&
                    selectedTitleCompanyData &&
                    Object.keys(selectedTitleCompanyData).length > 0 &&
                    titleSignerArray?.length > 0) && (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end" }}>
                            <Button
                                disabled={!selectedSigner}
                                onClick={handleConfirmSignerSelection}
                                size="middle"
                                type="primary"
                            >
                                Done
                            </Button>
                        </div>
                    )}

            </Modal>

            {/* PROCESSOR FORM */}
            {openProcessorForm &&
                <Modal
                    title={<div className='commonModalTitle'>Add Processor</div>}
                    visible={openProcessorForm}
                    footer={null}
                    bodyStyle={{ padding: 10 }}
                    onCancel={() => setOpenProcessorForm(false)}
                    destroyOnClose={true}
                    width={500}
                >
                    <Form
                        labelCol={{ span: 6, fontWeight: 'bold' }}
                        wrapperCol={{ span: 16 }}
                        onFinish={handleSubmitProcessor}
                    >
                        <Form.Item
                            label="Name"
                            name="name"
                            rules={[{ required: true, message: 'Please input the name!' }]}
                        >
                            <Input placeholder="Enter Name..." allowClear autoFocus />
                        </Form.Item>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[{ required: true, message: 'Please input the email!' }, { type: 'email', message: 'Please enter a valid email!' }]}
                        >
                            <Input placeholder="Enter Email..." allowClear />
                        </Form.Item>
                        <Form.Item
                            label={<div style={{ fontSize: "15px" }}>Phone Number</div>}
                            name="phoneNumber"
                            hasFeedback
                        >
                            <PhoneInput
                                inputStyle={{ width: '100%' }}
                                inputClass="phoneInput"
                                country={'us'}
                                onlyCountries={['us']}
                                maxLength="10"
                                international={false}
                                disableCountryCode={true}
                                placeholder="Enter Phone Number"
                                className="phone-input"
                                style={{ width: '286px !important' }}
                            />
                        </Form.Item>
                        <Form.Item style={{ textAlign: 'right' }}>
                            <Button onClick={() => setOpenProcessorForm(false)} style={{ marginRight: 8 }}>
                                Cancel
                            </Button>
                            <Button type="primary" htmlType="submit">
                                Add
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            }
        </div>
    )
}

export default TitleSignerList